// extracted by mini-css-extract-plugin
export default {"wrapper":"HoverTooltip_wrapper__1ZiW8","portalTooltip":"HoverTooltip_portalTooltip__y+-7R"};